import { Stack, Typography, Grid2 as Grid } from "@mui/material";
import { Content } from "@/types";
import RewardCard from "./RewardCard";
import { Skeleton } from "@mui/material";

interface LoyaltyAvailableRewardsProps {
    isLoading: boolean;
    isSuccess: boolean;
    rewards: Content[];
    currentPoints: number;
    onRedeem: (reward: Content) => void;
    readOnly?: boolean;
}

const LoyaltyAvailableRewards = ({ isLoading, isSuccess, rewards, currentPoints, onRedeem, readOnly }: LoyaltyAvailableRewardsProps) => {
    if (isLoading) {
        return (
            <Stack spacing={3}>
                <Skeleton variant="rounded" height={30} width={250} />
                <Grid container spacing={2}>
                    {[1, 2, 3].map((index) => (
                        <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index}>
                            <Skeleton variant="rounded" height={250} width="100%" />
                        </Grid>
                    ))}
                </Grid>
            </Stack>
        );
    }

    if (!isSuccess) {
        return null;
    }

    return (
        <Stack spacing={3}>
            <Typography variant="h3" mb={2}>
                Premios disponibles
            </Typography>
            {rewards.length > 0 ? (
                <Grid container spacing={2}>
                    {rewards.map((reward) => (
                        <Grid size={{ xs: 12, sm: 6, md: 4 }} key={reward.id}>
                            <RewardCard
                                reward={reward}
                                availablePoints={currentPoints}
                                onRedeem={onRedeem}
                                readOnly={readOnly}
                            />
                        </Grid>
                    ))}
                </Grid>
            ) : (
                <Typography variant="body2" color="textSecondary">
                    No hay premios disponibles en este momento.
                </Typography>
            )}
        </Stack>
    );
}

export default LoyaltyAvailableRewards;
